// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as App_Modal$DvmAdminFrontendFr from "../../App_Modal.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../button/App_Button.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../../intl/messages/Messages_Button.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../types/App_Types_Result.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../App_OverlaySpinner.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as App_TopMenu_Notifications_Api$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Api.bs.js";
import * as App_TopMenu_Notifications_Types$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Types.bs.js";

function App_TopMenu_Notifications_Allocations_Modal(Props) {
  var onClose = Props.onClose;
  var refetch = Props.refetch;
  var notifications = Props.notifications;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var match$3 = React.useState(function () {
        return Belt_List.keep(notifications, (function (x) {
                      return x.parent === /* ALLOCATIONS_TO_BE_CHECKED */0;
                    }));
      });
  var setAvailableNotifications = match$3[1];
  var availableNotifications = match$3[0];
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(result, undefined, (function (param) {
                  Curry._1(refetch, undefined);
                }));
        }), [result]);
  React.useEffect((function () {
          Curry._1(setAvailableNotifications, (function (param) {
                  return Belt_List.keep(notifications, (function (x) {
                                return x.parent === /* ALLOCATIONS_TO_BE_CHECKED */0;
                              }));
                }));
        }), [notifications]);
  React.useEffect((function () {
          if (Belt_List.length(availableNotifications) === 0) {
            Curry._1(onClose, undefined);
          }
          
        }), [availableNotifications]);
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.allocationsToBeChecked),
              minWidth: "900px",
              children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                    show: App_Types_Result$DvmAdminFrontendFr.isPending(result),
                    children: React.createElement(Core.Grid, {
                          children: Belt_List.toArray(Belt_List.map(availableNotifications, (function (notification) {
                                      return Belt_List.toArray(Belt_List.map(notification.child, (function (x) {
                                                        return Belt_Option.mapWithDefault(x.messageType, null, (function (message) {
                                                                      return React.createElement(Core.Grid, {
                                                                                  alignItems: "center",
                                                                                  children: null,
                                                                                  container: true,
                                                                                  item: true,
                                                                                  spacing: 1
                                                                                }, React.createElement(Core.Grid, {
                                                                                      children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                                                                            onClick: (function (param) {
                                                                                                var messageType = message;
                                                                                                var notificationType = notification.parent;
                                                                                                var detail = x.detail;
                                                                                                App_TopMenu_Notifications_Api$DvmAdminFrontendFr.dismissNotification(userManager, setResult, selectedRole, notificationType, messageType, detail);
                                                                                              }),
                                                                                            label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.noted),
                                                                                            color: "primaryBorder",
                                                                                            size: "small"
                                                                                          }),
                                                                                      item: true
                                                                                    }), React.createElement(Core.Grid, {
                                                                                      children: App_TopMenu_Notifications_Types$DvmAdminFrontendFr.MessageType.toMessageString(message, intl, Belt_Option.getWithDefault(x.detail, "")),
                                                                                      item: true
                                                                                    }));
                                                                    }));
                                                      })));
                                    }))),
                          container: true,
                          direction: "column",
                          spacing: 2
                        })
                  })
            });
}

var make = App_TopMenu_Notifications_Allocations_Modal;

export {
  make ,
}
/* react Not a pure module */
